(() => {
  'use strict';

  const ROOT_SELECTOR = '[id^="custom-bedding-quote-v2-"]';
  const PANEL_SELECTOR = '.som-cloudflare-authoritative-r1';
  const params = new URLSearchParams(window.location.search);
  const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();

  const diagnosticsVisible =
    window.Shopify?.designMode === true ||
    params.has('preview_theme_id') ||
    themeRole === 'unpublished' ||
    themeRole === 'development';

  function update(scope = document) {
    const panels = scope.querySelectorAll
      ? scope.querySelectorAll(PANEL_SELECTOR)
      : [];

    panels.forEach((panel) => {
      const calculator = panel.closest(ROOT_SELECTOR);
      const hasError = calculator?.dataset.somCloudflareMode === 'ERROR';

      // Technical success/progress messages stay visible while previewing,
      // but are hidden from customers after the theme becomes MAIN.
      // A real Cloudflare failure remains visible so the customer understands
      // why Add to Cart has been blocked.
      panel.hidden = !diagnosticsVisible && !hasError;
    });
  }

  update();

  const observer = new MutationObserver(() => update());
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-som-cloudflare-mode'],
  });

  document.addEventListener('shopify:section:load', (event) => update(event.target));
})();
